<template>
    <div class="email-verification-page">
        <div class="container">
            <h1>Verifica la tua Email</h1>
            <p v-if="!successMessage">Attendi mentre verifichiamo il tuo account...</p>

            <!-- Messaggi di successo o errore -->
            <p v-if="successMessage" class="white-text">{{ successMessage }}</p>
            <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>

            <button v-if="successMessage && (!nextRoute || nextRoute === '/login' || nextRoute === '/registration-complete')" @click="openDeepLink" class="btn btn-custom">Continua</button>
            <button v-else-if="successMessage" @click="goToHomePage" class="btn btn-custom">Continua</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            token: null, // Token recuperato dall'URL
            successMessage: '',
            errorMessage: '',
            nextRoute: '/login', // Rotta di default per il reindirizzamento dopo la verifica
            userToken: null
        };
    },
    created() {
        // Recupera il token dall'URL
        this.token = this.$route.query.token || null;

    this.nextRoute = this.$route.query.route || '/login';

        // Se il token esiste, effettua la richiesta di verifica
        if (this.token) {
            this.verifyEmail();
        } else {
            this.errorMessage = 'Token non valido. Non è possibile verificare l\'account.';
        }
    },
    methods: {
        async verifyEmail() {
            try {
                // Effettua la richiesta per verificare l'email
                const response = await fetch(`https://api.elitefitness.it/api/auth/verify?token=${this.token}`, {
                    method: 'GET'
                });

                if (response.ok) {
                    this.successMessage = 'La tua email è stata verificata con successo!';
                    this.errorMessage = '';
                    const data = await response.json();
                    console.log(data);
                    this.userToken = data.token;
                    console.log('Token utente:', this.userToken);
                    
                    // Salva il token nel localStorage per mantenere la sessione
                    if (this.userToken) {
                        localStorage.setItem('userToken', this.userToken);
                        if (data.expiresIn) {
                            localStorage.setItem('tokenExpiration', data.expiresIn);
                        }
                    }
                    
                    // Reindirizza automaticamente al nextRoute se specificato e non è mobile
                    if (this.nextRoute && this.nextRoute !== '/login') {
                        // Se nextRoute è /registration-complete, usa openDeepLink invece di goToHomePage
                        if (this.nextRoute === '/registration-complete') {
                            setTimeout(() => {
                                this.openDeepLink();
                            }, 1500);
                        } else {
                            // Aspetta un momento per mostrare il messaggio di successo
                            setTimeout(() => {
                                this.goToHomePage();
                            }, 1500);
                        }
                    }
                } else {
                    this.errorMessage = 'Verifica fallita. Token non valido o scaduto.';
                    this.successMessage = '';
                }
            } catch (error) {
                console.error('Email verification failed:', error);
                this.errorMessage = 'Si è verificato un errore durante la verifica. Riprova più tardi.';
                this.successMessage = '';
            }
        },
        openDeepLink() {
            const deeplink = "elitefitness://elitefitness.it";
            const iosStore = "https://apps.apple.com/it/app/id6670614281";
            const androidStore = "https://play.google.com/store/apps/details?id=it.utopialabs.elitefitness";
            const fallbackWeb = "https://elitefitness.it"; // opzionale

            const ua = navigator.userAgent || navigator.vendor || window.opera;
            let storeUrl;

            if (/android/i.test(ua)) {
                storeUrl = androidStore;
            } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
                storeUrl = iosStore;
            } else {
                // Desktop o altro → vai al sito (puoi cambiarlo in uno store generico)
                window.location = fallbackWeb;
                return;
            }

            const now = Date.now();
            window.location = deeplink;

            setTimeout(() => {
                if (Date.now() - now < 1600) {
                    window.location = storeUrl;
                }
            }, 1500);
        },
        goToHomePage() {
            const route = this.nextRoute; // path like /redeem-gift-card or /redeem-gift-card?code=XXX
            const [path, queryString] = route.split('?');
            const existingParams = new URLSearchParams(queryString || '');
            
            // Se c'è un token, aggiungilo ai query params (per compatibilità)
            if (this.userToken) {
                existingParams.set('userToken', this.userToken);
            }

            // Usa replace invece di push per evitare di tornare indietro alla pagina di verifica
            this.$router.replace({
                path: path,
                query: Object.fromEntries(existingParams)
            });
        }
    }
};
</script>

<style scoped>
.email-verification-page {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #292D7D;
    color: white;
}

.text-danger {
    color: red;
}

.text-success {
    color: rgb(255, 255, 255);
}

.btn-custom {
    font-family: 'Montserrat', sans-serif;
    background-color: #e83539;
    color: white;
    border: none;
    padding: 10px 20px;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 0.3s ease;
    border-radius: 0;
    font-size: 1.2rem;
}

.btn-custom:hover {
    background-color: #cc2e31;
    color: white;
}

.form-control {
    font-family: 'Montserrat', sans-serif;
    background-color: rgba(255, 255, 255, 0);
    border: 2px solid;
    border-color: white;
    border-radius: 0px;
    color: white;
    margin: 10px;
}

.form-control::placeholder {
    color: rgba(255, 255, 255, 0.6);
}
</style>
